module.exports = __webpack_public_path__ + "static/media/view_capsules.d3d0fc05.svg";